/**
 * All route paths in this file
 */
const Paths = {
  Login: '/login',
  ForgotPassword: '/forgot-password',
  Dashboard: '/dashboard',
  Administrators: '/administrators',
  Customers: '/customers',
  createCustomer: '/customers/create',
  editCustomers: '/customers/edit/:id',
  Users: '/users',
  Courses: '/courses',
  AddCourses: '/courses/create',
  updateCourses: '/courses/create/:id',
  EditUsers: '/users/edit',
  UpdateUsers: '/users/edit/:id',
  AddUsers: '/users/create',
  AddAdministrator: '/administrators/create',
  UpdateAdministrator: '/administrators/create/:id',
  MyAssessments: '/myassessments',
  Profile: '/profile',
  Liceses: '/licenses',
  Experiments: '/experiments',
  AddExperiment: '/experiments/create',
  Reporting: '/reporting/overview',
  DigitalReadliness: '/reporting/digital-readliness',
  DigitalTalentMaturity: '/reporting/digital-talent-maturity/:tab?',
  AIMaturity: '/reporting/digital-ai-maturity/:tab?',
  LearningService: '/reporting/learning-service/:type?',
  Calendar: '/calendar',
  ChangePassword: '/change-password',
  Deployments: '/deployments',
  createDeployment: '/deployments/create',
  updateDeployment: '/deployments/create/:id',
  CustomerOnBoarding: '/flowcustomer/:id?',
  ThemeEditor: '/themeeditor/customer/:id?',
  CourseRequests: '/course-requests',
  LearningHubRequests: '/learning-hub-requests',
  CourseListing: '/course-listing',
  CourseDetails: '/course/:id',
  SuperadminCustomerInsights: '/superadmin/customers/:customerId',
  SuperadminProjects: '/superadmin/projects',
  SuperadminProjectInsights: '/superadmin/projects/:projectId',
};

const UserPath = {
  UserDashboard: '/user/dashboard',
  Assessments: '/assessments',
  CourseCatalogue: '/skill-transformation/course-catalogue',
  LearningHub: '/learning-hub',
  RegisteredCourses: '/my-courses/registered-courses',
  RegisteredCoursesLegacy: '/skill-transformation/registered-courses',
  RegisteredCoursesRoot: '/my-courses',
  MyLearningHubCourses: '/my-courses/my-learning-hub-courses',
  MyLearningHubCoursesLegacy: '/skill-transformation/my-learning-hub-courses',
  RegisteredGroupCousres: '/skill-transformation/registered-groups',
  WorkReadyness: '/skill-transformation/work-readiness',
  VirtualGlobalApprenticeship: '/skill-transformation/virtual-global-apprenticeship',
  Calendar: '/calendar',
  MainPage: '/main',
  HomePage: '/home',
}

export {
  Paths,
  UserPath
};
